import type { StateCreator } from 'zustand';

import type { GlobalStore, SnackbarSlice } from '../schema';

export const createSnackbarSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  SnackbarSlice
> = (set) => ({
  snackbar: { message: '' },
  setSnackbar: (snackbar) => set({ snackbar }, false, 'snackbar/set'),
});
